import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

interface ChatPart {
  text: string;
}

interface ChatMessage {
  role: 'user' | 'model';
  parts: ChatPart[];
}

interface CloudFunctionResponse {
  success: boolean;
  data: any[];
  resultsCount: number;
  sqlQuery?: string;
  chatHistory?: ChatMessage[];
  error?: string;
  details?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BuyercaddyDataAgentService {
  private functionUrl = 'https://sql-agent-nodejs-972736928837.us-central1.run.app/generate-sql';
  private currentChatHistory: ChatMessage[] | null = null;

  constructor(private http: HttpClient) { }

  fetchData(prompt: string, topNum: number = 25): Observable<CloudFunctionResponse> {
    const requestBody: {
      user_query: string;
      top_num: number;
      chatHistory?: ChatMessage[] | null;
    } = {
      user_query: prompt,
      top_num: topNum
    };

    if (this.currentChatHistory && this.currentChatHistory.length > 0) {
      requestBody.chatHistory = this.currentChatHistory;
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<CloudFunctionResponse>(this.functionUrl, requestBody, { headers })
      .pipe(
        tap(response => {
          // Если запрос успешен и бэкенд вернул историю, обновляем ее
          if (response.success && response.chatHistory) {
            this.currentChatHistory = response.chatHistory;
          } else if (!response.success) {
            // Если запрос не удался, можно решить, очищать ли историю.
            // Пока оставим ее, чтобы пользователь мог попробовать исправить запрос с тем же контекстом.
            // Если ошибка явно связана с историей (например, слишком длинная),
            // то здесь можно было бы вызвать this.resetChatHistory();
            console.error('Cloud Function call failed:', response.error, response.details);
          }
          // Если response.chatHistory не пришел (например, при ошибке на бэкенде до формирования ответа LLM)
          // this.currentChatHistory останется прежним.
        })
      );
  }

  public resetChatHistory(): void {
    this.currentChatHistory = null;
    console.log('Chat history has been reset.');
  }

  public getCurrentChatHistory(): ChatMessage[] | null {
    // Возвращаем копию, чтобы внешние компоненты не могли напрямую модифицировать историю сервиса
    return this.currentChatHistory ? [...this.currentChatHistory] : null;
  }
}